import type { ReactNode } from "react";
import { Button, IconButton } from "@NP-Webber/crm-kit/dist/next/index.js";
import type { CkMenuItem } from "@NP-Webber/crm-kit/dist/next/index.js";
import { ScreenHeader } from "../next/page/ScreenHeader";

export type ListPageHeaderProps = {
  onRefresh?: () => void;
  refreshLabel?: string;
  primaryLabel?: string;
  onPrimary?: () => void;
  primaryDisabled?: boolean;
  secondary?: ReactNode;
  /**
   * The screen's own header (title from the menu + sub line + "?" help). Without it the header is a
   * compact toolbar for a section inside a screen (a tab of suppliers, receipts, categories…).
   */
  screen?: boolean;
  title?: ReactNode;
  sub?: ReactNode;
  /** extra ⋮ menu items (screen header) */
  more?: CkMenuItem[];
};

/** List actions (refresh / add) — the new-design page header or a section toolbar. */
export function ListPageHeader({
  onRefresh,
  refreshLabel = "רענון",
  primaryLabel,
  onPrimary,
  primaryDisabled,
  secondary,
  screen = false,
  title,
  sub,
  more = [],
}: ListPageHeaderProps) {
  if (screen) {
    return (
      <ScreenHeader
        title={title}
        sub={sub}
        primary={onPrimary && primaryLabel && !primaryDisabled ? { label: primaryLabel, icon: "plus", onClick: onPrimary } : undefined}
        more={[...(onRefresh ? [{ key: "refresh", label: refreshLabel, icon: "refresh", onClick: onRefresh }] : []), ...more]}
      >
        {secondary}
      </ScreenHeader>
    );
  }
  const hasActions = Boolean(onRefresh || onPrimary || secondary || title);
  if (!hasActions) {
    return null;
  }
  return (
    <div className={`page-section__header${title ? "" : " page-section__header--actions-only"}`}>
      {title ? <h2 className="page-section__title">{title}</h2> : null}
      <div className="page-section__actions">
        {secondary}
        {onRefresh ? <IconButton icon="refresh" label={refreshLabel} onClick={onRefresh} /> : null}
        {onPrimary && primaryLabel ? (
          <Button variant="primary" icon="plus" onClick={onPrimary} disabled={primaryDisabled}>
            {primaryLabel}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
